import React, { useState } from "react";
import { usePaystackPayment } from "react-paystack";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

function Donate() {
	const navigate = useNavigate();
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [amount, setAmount] = useState(Number);

	const config = {
		reference: new Date().getTime().toString(),
		email,
		amount: amount * 100,
		publicKey: "pk_live_2732df7378e84dbe0013bb9fd7f00faad438e244",
	};

	const onSuccess = (reference) => {
		console.log(reference);
		navigate("/success");
	};

	const onClose = () => {
		console.log("closed");
	};

	const initializePayment = usePaystackPayment(config);

	return (
		<Conatiner>
			<Wrapper>
				<Card>
					<Image
						src="https://firebasestorage.googleapis.com/v0/b/codelab-admission.appspot.com/o/social%2Fsimple.png?alt=media&token=99f4b576-37f6-4ba3-8716-686effea539f"
						alt="Logo"
					/>
					<ImageLabel htmlFor="image">
						Thank you for Considering to Support us
					</ImageLabel>

					<Div>
						<Label>Name</Label>
					</Div>
					<Input
						placeholder="Enter your Name"
						value={name}
						onChange={(e) => {
							setName(e.target.value);
						}}
					/>

					<Div>
						<Label>Email</Label>
					</Div>
					<Input
						placeholder="Enter your Email"
						value={email}
						onChange={(e) => {
							setEmail(e.target.value);
						}}
					/>

					<Div>
						<Label>Amount</Label>
					</Div>
					<Input
						placeholder="Amount You would love to Support us with"
						value={amount}
						onChange={(e) => {
							setAmount(e.target.value);
						}}
					/>

					<Button
						type="submit"
						onClick={() => {
							initializePayment(onSuccess, onClose);

							localStorage.setItem(
								"payer",
								JSON.stringify({ name, email, amount })
							);
						}}
					>
						Pay Now
					</Button>
				</Card>
			</Wrapper>
		</Conatiner>
	);
}

export default Donate;

const Div = styled.div`
	display: flex;
	justify-content: center;
`;

const Label = styled.label`
	color: #004080;
	display: flex;
	justify-content: flex-start;
	width: 100%;
	/* padding-left: 10px; */
	font-size: 12px;
	font-weight: bold;
	margin-top: 10px;
`;

const Button = styled.div`
	border-radius: 4px;
	padding: 15px 40px;
	background: #004080;
	color: white;
	margin: 0 10px;
	transition: all 350ms;
	transform: scale(1);
	border: 0;
	font-weight: bold;
	outline: none;

	:hover {
		cursor: pointer;
		transform: scale(0.97);
	}

	@media screen and (max-width: 5000px) {
		margin-top: 20px;
	}
`;

const Input = styled.input`
	margin: 5px 0;
	width: 300px;
	height: 40px;
	outline: none;
	border: 1px solid black;
	border-radius: 5px;
	padding-left: 10px;

	::placeholder {
		font-family: Poppins;
	}
`;

const ImageLabel = styled.label`
	text-align: center;
	background: #004080;
	padding: 15px 40px;
	color: white;
	border-radius: 5px;
	margin-bottom: 20px;
	transition: all 350ms;
	transform: scale(1);

	:hover {
		cursor: pointer;
		transform: scale(0.97);
	}
	@media screen and (max-width: 5000px) {
		padding: 15px 20px;
	}
`;

const ImageInput = styled.input`
	display: none;
`;

const Image = styled.img`
	width: 100px;
	height: 100px;
	border-radius: 100%;
	object-fit: cover;
	background: white;
	margin: 20px 0;
	border: 1px solid lightgrey;
`;

const Card = styled.form`
	width: 500px;
	min-height: 200px;
	padding: 30px 0;
	background: white;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Wrapper = styled.div`
	padding-top: 100px;
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Conatiner = styled.div`
	width: 100%;
	height: calc(100vh - 100px);
	height: 100%;
	background: lightgray;
`;
